import { formattedDollarsToCents, isEmpty } from '@fruitful/fruitils';
import { type z, ZodIssueCode } from 'zod';

type ZodCtx = z.RefinementCtx;

export const validateTargetBalance = (
    targetBalance: string | undefined,
    ctx: ZodCtx,
): boolean => {
    if (isEmpty(targetBalance)) {
        ctx.addIssue({
            code: ZodIssueCode.custom,
            path: [`goalSettings.targetBalance`],
            message: 'Please enter a value greater than 0',
        });
        return false;
    }

    const cents = formattedDollarsToCents(targetBalance as string);
    if (cents <= 0) {
        ctx.addIssue({
            code: ZodIssueCode.custom,
            path: [`goalSettings.targetBalance`],
            message: 'Please enter a value greater than 0',
        });
        return false;
    }

    return true;
};
